export const ToolbarItemDivider = () => {
    return <div className="divider" />;
}